// Imports
var ___CSS_LOADER_API_IMPORT___ = require("E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-5b5c40a0]{height:calc(100vh);\nheight:calc(100vh - var(--window-top));\ndisplay:flex;flex-direction:column;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
